import { computed } from '@ember/object';
export default function delta(propertyOne, propertyTwo) {
  return computed(propertyOne, propertyTwo, function () {
    const propOne = this.get(propertyOne);
    const propTwo = this.get(propertyTwo);
    return (propOne === undefined ? 0 : propOne) - (propTwo === undefined ? 0 : propTwo);
  });
}